import { useRef } from "react"
import { CanvasDrawer } from "../../CanvasDrawer";

export default function usePan() {
    const lastTouchPos = useRef<null | { x: number; y: number }>(null);
    const isPanning = useRef(false);

    const startSingleFingerPan = (e: React.TouchEvent<HTMLCanvasElement>) => {
        const touch = e.touches[0];
        lastTouchPos.current = {
            x: touch.clientX,
            y: touch.clientY,
        };
    };

    const moveSingleFingerPan = (e: React.TouchEvent<HTMLCanvasElement>) => {
        if (lastTouchPos.current == null || e.touches.length !== 1) return;

        const touch = e.touches[0];
        const curTouch = { x: touch.clientX, y: touch.clientY };

        const dx = curTouch.x - lastTouchPos.current.x;
        const dy = curTouch.y - lastTouchPos.current.y;

        const xBounds = 150;
        const yBounds = 400;

        if (CanvasDrawer.offset.x + dx < xBounds && CanvasDrawer.offset.x + dx > -xBounds) {
            CanvasDrawer.offset.x += dx;
        }

        if (CanvasDrawer.offset.y + dy < yBounds && CanvasDrawer.offset.y + dy > -yBounds) {
            CanvasDrawer.offset.y += dy;
        }

        lastTouchPos.current = curTouch;

        CanvasDrawer.rerenderCanvas();
    };

    const endSingleFingerPan = () => {
        lastTouchPos.current = null;
    };

    const startMousePan = (e: React.MouseEvent<HTMLCanvasElement>) => {
        isPanning.current = true;
        lastTouchPos.current = {
            x: e.clientX,
            y: e.clientY,
        };
    };

    const moveMousePan = (e: React.MouseEvent<HTMLCanvasElement>) => {
        if (!isPanning.current || lastTouchPos.current == null) return;

        const curPos = { x: e.clientX, y: e.clientY };

        const dx = curPos.x - lastTouchPos.current.x;
        const dy = curPos.y - lastTouchPos.current.y;

        const xBounds = 150;
        const yBounds = 400;

        if (CanvasDrawer.offset.x + dx < xBounds && CanvasDrawer.offset.x + dx > -xBounds) {
            CanvasDrawer.offset.x += dx;
        }

        if (CanvasDrawer.offset.y + dy < yBounds && CanvasDrawer.offset.y + dy > -yBounds) {
            CanvasDrawer.offset.y += dy;
        }

        lastTouchPos.current = curPos;

        CanvasDrawer.rerenderCanvas();
    };

    const endMousePan = () => {
        isPanning.current = false;
        lastTouchPos.current = null;
    };

    return {
        startSingleFingerPan,
        moveSingleFingerPan,
        endSingleFingerPan,
        startMousePan,
        moveMousePan,
        endMousePan,
    };
}